import React from 'react';
import { Eye, Activity, History, Briefcase, Building, Clock } from 'lucide-react';
import { StaffAvatar } from './StaffAvatar';
import { RolePill, StatusPills } from './StaffBadges';
import { roleMeta, relativeTime } from './peopleUtils';

export const StaffCard = ({ staff, selected, onToggle, online, onLeave, probation, isSelf, actions, index = 0 }) => {
  const hex = roleMeta(staff.role).hex;
  return (
    <div data-testid={`staff-card-${staff.username}`} onClick={() => actions.quickView(staff)}
      style={{ animationDelay: `${Math.min(index, 12) * 35}ms` }}
      className={`group relative cursor-pointer overflow-hidden rounded-2xl border bg-[#0A0A12]/70 backdrop-blur-md p-4 transition-[transform,border-color] duration-300 hover:-translate-y-0.5 animate-[jewelFadeUp_0.4s_ease-out_both] ${selected ? 'border-cyan-400/50' : 'border-white/[0.07] hover:border-white/[0.16]'} ${staff.is_suspended ? 'opacity-70' : ''}`}>
      <div className="pointer-events-none absolute -top-14 -right-10 w-36 h-36 rounded-full blur-[70px] opacity-30 group-hover:opacity-60 transition-opacity" style={{ background: hex }} />
      <div className="relative">
        <div className="flex items-start gap-3">
          <StaffAvatar staff={staff} size="w-12 h-12" online={online} testId={`online-dot-${staff.username}`} />
          <div className="flex-1 min-w-0">
            <p className="text-white text-sm font-medium truncate">{staff.display_name || staff.username}{isSelf && <span className="ml-1.5 text-[9px] text-cyan-300">(you)</span>}</p>
            <p className="text-white/40 text-[11px] truncate">@{staff.username}</p>
          </div>
          <input type="checkbox" checked={selected} onClick={(e) => e.stopPropagation()} onChange={() => onToggle(staff.username)}
            data-testid={`select-staff-card-${staff.username}`} className="w-4 h-4 mt-1 accent-cyan-400 cursor-pointer" />
        </div>
        <div className="mt-3 flex items-center gap-1.5 flex-wrap"><RolePill role={staff.role} /><StatusPills staff={staff} onLeave={onLeave} probation={probation} /></div>
        <div className="mt-3 space-y-1 text-[11px] text-white/50">
          <p className="flex items-center gap-2 truncate"><Briefcase className="w-3 h-3 text-white/25" />{staff.job_title || 'No title'}</p>
          <p className="flex items-center gap-2 truncate"><Building className="w-3 h-3 text-white/25" />{staff.department || 'No department'}</p>
        </div>
        <div className="mt-3 pt-3 border-t border-white/[0.05] flex items-center justify-between">
          <span className="flex items-center gap-1 text-[10px] text-white/35"><Clock className="w-3 h-3" />{relativeTime(staff.last_login)}</span>
          <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
            {[[Eye, 'quickView', 'Quick view', 'card-view'], [Activity, 'hrProfile', 'HR profile', 'card-hr'], [History, 'actionLog', 'Action log', 'card-log']].map(([Ic, key, title, tid]) => (
              <button key={key} onClick={() => actions[key](staff)} title={title} data-testid={`${tid}-${staff.username}`}
                className="p-1.5 rounded-lg text-white/40 hover:text-cyan-200 hover:bg-white/[0.06] transition-colors"><Ic className="w-3.5 h-3.5" /></button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
